import Icon from 'ui/Element/Icon'
import CellHOC from 'platform/react/hoc/list/cell'
import { Box } from '@mui/material'

const styles = () => ({
  root: {
    width: '2.5rem',
    height: '2.5rem',
    marginRight: '0.75rem',
    display: 'flex',
  },
  image: {
    maxWidth: '2.5rem',
    width: '100%',
    height: '100%',
  },
})

/**
 * ListItemCellPartIcon element.
 *
 * Displays an icon.
 *
 * @param {Object} classes  styles for the component
 * @param {Object} props    element's properties
 * @returns {JSX.Element}   the new ListItemCellIcon element
 */
export const ListItemCellPartIcon = (classes, props = {}) => {
  const { icon: { name } = {} } = props || {}

  return (
    <Box className={classes.root}>
      <Icon
        source={name || props.icon}

        shape={'circle'}
        color={'gray.400'}
        iconPadding={'0.5rem'}
        background={'gray.960'}
      />
    </Box>
  )
}

export default CellHOC(ListItemCellPartIcon, styles)
